"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusSelector = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var input_select_1 = require("../../components/input/input.select");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var page_state_1 = require("../../state/page.state");
var collection_status_modal_style_1 = require("./collection.status.modal.style");
var status_selector_ctrl_1 = require("./status.selector.ctrl");
var StatusSelector = /** @class */ (function (_super) {
    tslib_1.__extends(StatusSelector, _super);
    function StatusSelector() {
        var _this = _super.call(this) || this;
        _this.ctrl = new status_selector_ctrl_1.StatusSelectorCtrl();
        _this.inputState = new input_select_1.SelectInputState(i18n_1.T.STATUS);
        _this.inputState.isRequired = false;
        _this.reaction(function () { return _this.inputState.value; }, function (status) { return _this.ctrl.selectStatus(status); }, { fireImmediately: true });
        _this.reaction(function () { return _this.ctrl.statusOptions; }, function (options) {
            _this.inputState.setOptions(options);
            _this.inputState.setValue(null);
        }, { fireImmediately: true });
        return _this;
    }
    Object.defineProperty(StatusSelector.prototype, "nodes", {
        get: function () {
            if (this.inputState == null) {
                return null;
            }
            if (this.ctrl.loadingStatuses) {
                return spinner_1.Spinner.view();
            }
            return input_select_1.SelectInputComponent.view(this.inputState);
        },
        enumerable: false,
        configurable: true
    });
    StatusSelector.prototype.selectedStats = function () {
        if (!this.ctrl.selectedStatus) {
            return null;
        }
        var count = 0;
        for (var _i = 0, _a = this.ctrl.allStatuses; _i < _a.length; _i++) {
            var stats = _a[_i];
            if (stats.statuses.indexOf(this.selectedStatus) > -1) {
                count++;
            }
        }
        return (0, mithril_1.m)('ul', { className: collection_status_modal_style_1.CSS.list }, [
            (0, mithril_1.m)('li', this.selectedStatus + ': ' + count),
            (0, mithril_1.m)('li', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_STATUS_CANNOT_CHANGE, { count: page_state_1.CurrentState.Tag.collections.length - count }))
        ]);
    };
    Object.defineProperty(StatusSelector.prototype, "selectedStatus", {
        get: function () {
            return this.ctrl.selectedStatus;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], StatusSelector.prototype, "selectedStatus", null);
    return StatusSelector;
}(mithril_component_1.IMithrilStateComponent));
exports.StatusSelector = StatusSelector;
//# sourceMappingURL=status.selector.js.map